export default __webpack_public_path__ + "content/media/10.ad200b53.jpg";